import axios from 'axios';
import Qs from 'qs';
//引入状态管理 - rbac权限判断
import commons from '@/util/commons.js';
// 主接口
const mianApi = axios.create({});
//请求前
mianApi.interceptors.request.use(config=>{
    //根地址
    config.baseURL = process.env.BASE_URL;
    //超时时间
    config.timeout = 30000;
    //Authorization 配置 模拟登录token
    var localUser = commons.readTodos('localUser');
    config.headers.Authorization = localUser.token;
    //返回配置信息
	return config;
});
//请求后
mianApi.interceptors.response.use(config => {
	return config;
});
/**
* get方法，对应get请求
* @param {String} url [请求的url地址]
* @param {Object} params [请求时携带的参数]
*/
const mianApiGet = function get(url, params){
    params = Qs.stringify(params);
    return new Promise((resolve, reject) =>{
        mianApi.get(url, {
            params: params
        }).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err.data)
        })
    });
}
/**
* post方法，对应post请求
* @param {String} url [请求的url地址]
* @param {Object} params [请求时携带的参数]
*/
const mianApiPost =  function post(url, params) {
    params = Qs.stringify(params);
    return new Promise((resolve, reject) => {
        mianApi.post(url, params).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err.data)
        })
    });
}
//抛出函数
export {mianApiGet,mianApiPost};



// WEBPACK FOOTER //
// ./src/request/http.js